import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ProjectCards from "../Projekti/ProjectCards";

function Projekti() {
  const [t] = useTranslation();

  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Projekti" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">{t("projekti.title")}</h2>
              <div className="textjustify">
                <p>{t("projekti.p1")}</p>
                <p>{t("projekti.p2")}</p>
                <p>{t("projekti.p3")}</p>
                <p>{t("projekti.p4")}</p>
              </div>

              <ProjectCards
                layout="sidebar"
                title={t("projects.sidebar.title")}
                subtitle={t("projects.sidebar.subtitle")}
              />

              <div className="ofpep-section">
                <h3 className="pb-10">{t("projekti.nekiod")}</h3>
                <table className="table">
                  <thead>
                    <tr>
                      <th>{t("projekti.rb")}</th>
                      <th>{t("projekti.nazivProjekta")}</th>
                      <th>{t("projekti.norm")}</th>
                      <th>{t("projekti.izvorfin")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1.</td>
                      <td>
                        Introducing ISO 9001:2015 + IWA 2 recommendations for
                        higher education
                      </td>
                      <td>N</td>
                      <td>EBRD (sufinansiranje)</td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>Preparation of the Curriculum of Open Innovation</td>
                      <td>M</td>
                      <td>
                        Erasmus+ call for proposals - Capacity Building in the
                        field of Youth 2020
                      </td>
                    </tr>
                    <tr>
                      <td>3.</td>
                      <td>
                        Koorganizacija naučne konferencije EECME - Eastern
                        European Conference of Management and Economics
                      </td>
                      <td>M</td>
                      <td>Samostalno</td>
                    </tr>
                    <tr>
                      <td>4.</td>
                      <td>
                        Koorganizacija naučne konferencije COAST - International
                        Conference on Advances in Science And Technology
                      </td>
                      <td>M</td>
                      <td>Samostalno</td>
                    </tr>
                    <tr>
                      <td>5.</td>
                      <td>International Summer School Bar “Beyond Horizon”</td>
                      <td>M</td>
                      <td>Samostalno</td>
                    </tr>
                    <tr>
                      <td>6.</td>
                      <td>Kratkoročna naučna mobilnost istraživača</td>
                      <td>M</td>
                      <td>
                        Ministarstvo prosvjete nauke i inovacija Crne Gore
                      </td>
                    </tr>
                    <tr>
                      <td>7.</td>
                      <td>MED NETWORK</td>
                      <td>M</td>
                      <td>EU S3 pametna specijalizacija</td>
                    </tr>
                    <tr>
                      <td>8.</td>
                      <td>
                        mYouth Marketing Leaders for Sustainable Development
                      </td>
                      <td>M</td>
                      <td>EU</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">{t("sidebar.follow")}</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Facebook"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Instagram"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">{t("sidebar.useful")}</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">{t("about.fpep")}</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">
                      {t("admission.Akreditacija")}
                    </Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">{t("upis.title")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">{t("admission.Skolarina")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">{t("saradnja.projekti")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">{t("studenti.dom")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">{t("navbar.Gallery")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">{t("navbar.News")}</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">{t("sidebar.study")}</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>{t("programs.osnovne")}</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      {t("osnovne.rfb")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      {t("osnovne.menadzment")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      {t("osnovne.pravo")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>{t("programs.master")}</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      {t("master.poslovnaEkonomija")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      {t("master.ekonomijaJavnogSektora")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      {t("master.pravo")}
                      <br />
                    </Link>
                  </li>

                  <li>
                    <span className="post-date">
                      <strong>{t("programs.specijalisticke")}</strong> <br />
                    </span>
                    <Link to="/menadzment-javnog-sektora-specijalisticke">
                      {t("specijalisticke.mjs")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment-profitnog-sektora-specijalisticke">
                      {t("specijalisticke.mps")}
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Projekti;
